import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import Blockamatic from "./Blockamatic.jsx";

// ─── Service Worker Registration ──────────────────────────────────────────────

const updateSW = registerSW({
  immediate: true,
  // Called when a new SW is available
  onNeedRefresh() {
    // In production you'd show a toast: "New version available — tap to update"
    // For now, auto-update silently
    updateSW(true);
  },
  onOfflineReady() {
    console.log("[Blockamatic] App ready for offline use");
  },
  onRegistered(registration) {
    console.log("[Blockamatic] SW registered:", registration);
  },
  onRegisterError(error) {
    console.error("[Blockamatic] SW registration failed:", error);
  },
});

const triggerUpdateCheck = () => {
  try {
    updateSW(true);
  } catch (error) {
    console.warn("[Blockamatic] SW update check failed:", error);
  }
};

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") triggerUpdateCheck();
});
window.addEventListener("focus", triggerUpdateCheck);
setInterval(triggerUpdateCheck, 60_000);

// ─── Mount ────────────────────────────────────────────────────────────────────

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Blockamatic />
  </StrictMode>
);
